import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@ngneat/transloco';
import { Locale, scopeLoader } from 'scoped-translations';
import { CheckForUpdateStore } from './check-for-update.store';

@Component({
  selector: 'elio-check-for-update',
  templateUrl: './check-for-update.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: {
    class: 'my-5 rounded w-fit max-w-lg z-40 h-full',
  },
  styles: [
    `
      ::ng-deep .mat-mdc-dialog-surface {
        @apply h-fit max-w-lg #{!important};
      }
    `,
  ],
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: {
        scope: 'checkForUpdate',
        loader: scopeLoader((lang: Locale) => import(`./i18n/${lang}.json`)),
      },
    },
  ],
  imports: [CommonModule, MatDialogModule, TranslocoModule],
})
export class CheckForUpdateComponent {
  constructor(
    private checkForUpdateStore: CheckForUpdateStore,
    public dialogRef: MatDialogRef<CheckForUpdateComponent>
  ) {}

  onUpdateVersionNow = () => this.checkForUpdateStore.applyNewVersion();
  onStartDelayTimer = () => this.checkForUpdateStore.startDelay();
}
